import { ReactElement } from 'react';

import { DropdownItem } from 'reactstrap';

import { FontAwesomeIcon, If, Then } from '@hsp/react-component-library';
import { isDefined, isOfType } from '@hsp/utilities';

import {
  SaveActionCustom,
  SaveActionDivider,
  SaveActionElement,
  SaveActionIcon,
  SaveActionProps,
} from 'types/pages/audience-builder/shared/save';

export const useSaveActionConfiguration = (props: SaveActionProps, className: string) => {
  let Component: ReactElement | null = null;

  if (isOfType<SaveActionDivider>(props, 'divider')) {
    Component = <DropdownItem divider />;
  } else {
    const { children, disabled, onAction } = props;
    let Element: ReactElement | null;

    if (isOfType<SaveActionCustom>(props, 'custom')) {
      Component = <>{props.custom}</>;
    } else {
      const { label } = props;

      if (isOfType<SaveActionIcon>(props, 'icon') && isDefined(props.icon)) {
        Element = <FontAwesomeIcon icon={props.icon} />;
      } else if (isOfType<SaveActionElement>(props, 'element') && isDefined(props.element)) {
        Element = <>{props.element}</>;
      } else {
        Element = null;
      }

      Component = (
        <DropdownItem
          disabled={disabled}
          onClick={onAction}>
          <div className="align-items-center d-flex">
            <div className={className}>
              <If condition={isDefined(Element)}>
                <Then>{() => <>{Element}</>}</Then>
              </If>
            </div>
            <div className="flex-grow-1 ms-2">{isDefined(children) ? children : label}</div>
          </div>
        </DropdownItem>
      );
    }
  }

  return Component;
};
